const range = (start, end) =>
	new Array(end - start + 1)
		.fill()
		.map((_, index) => start + index);
export default range;
